import { render, staticRenderFns } from "./PhonebookContact.vue?vue&type=template&id=0b9a7781&scoped=true&"
import script from "./PhonebookContact.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PhonebookContact.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./PhonebookContact.vue?vue&type=style&index=0&id=0b9a7781&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9a7781",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b9a7781')) {
      api.createRecord('0b9a7781', component.options)
    } else {
      api.reload('0b9a7781', component.options)
    }
    module.hot.accept("./PhonebookContact.vue?vue&type=template&id=0b9a7781&scoped=true&", function () {
      api.rerender('0b9a7781', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuPhonebook/components/PhonebookContact.vue"
export default component.exports